<template>
  <div class="footer">
    <div class="container">
      <div class="footer__contact">
        <h3>{{texts.title}}</h3>
        <div class="block block--even">
          <p class="footer__contact-text" v-html="texts.leftBlock"></p>
        </div>
        <div class="block block--even">

          <div class="inputs">
            <input class="user-data" id="name_surname" type="text" name="name_surname" v-bind:placeholder="texts.placeHolders[0]" required v-model="nameSurname"/>
            <input class="user-data" id="company" type="text" name="company" v-bind:placeholder="texts.placeHolders[1]" v-model="company"/>
            <input class="user-data" id="email" type="email" name="email" v-bind:placeholder="texts.placeHolders[2]" v-model="mail"/>
            <textarea class="user-data comment" id="comment" type="text" name="comment" v-bind:placeholder="texts.placeHolders[3]" v-model="additionalText"/>

            <!-- text area -->
          </div>

          <button name="TryButton" @click="sendFeedback" class="button button--try button--rounded">{{texts.submit}}</button>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="container">
        <p class="copyright__text">{{texts.copyright}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterMenu',
  data() {
    return {
      nameSurname: '',
      company: '',
      mail: '',
      additionalText: '',
    }
  },
  computed: {
    organizedData() {
      return {
        name: this.nameSurname,
        company: this.company,
        mail: this.mail,
        text: this.additionalText,
      }
    },
    state() {
      return this.$root.$data.state;
    },
    texts() {
      return this.state.system.footer
    },
  },
  methods: {
    tryProduct() {
      console.log('try product pressed');
      this.$root.$data.showOrder({ orderType: 'multiple' });
    },
    sendFeedback() {
      console.log('sending feedback');
      this.$root.$data.sendFeedback({ data: this.organizedData });
    },
  },
};
</script>

<style scoped lang="stylus">

@import '../../styles/common.styl'

.footer
  margin-bottom 95px
  background-color $OTSnavBlue
  +mobileXS()
    margin-bottom 45px
  +mobile()
    margin-bottom 85px
  &__contact
    margin-bottom 50px
    +mobile()
      margin 0px 15px
    h3
      text-align center
      color #fff
      font-weight 300
      padding-top 80px
      margin-bottom 55px
      +mobile()
        padding-top 30px
        margin-bottom 10px
    .button
      &--try
        padding 15px 55px
        margin-left 0px
        margin-top 15px
        font-weight 300
        +mobile()
          width 100%
  &__logo
    background-image url('../../assets/logo.png')
    background-size contain
    background-repeat no-repeat
    background-position center center
    width 242px
    height 39px
    margin-bottom 35px
    +mobile()
      display none
  &__contact-text
    color #797979
    padding-right 150px
    line-height 24px
    +mobile()
      padding 0px
      margin-bottom 10px
    +mobileXS()
      display none
  .copyright
    background-color #333
    height 40px
    margin-top 15px
    &__text
      color lighten(#333, 40%)
      text-transform uppercase
      line-height 40px
      font-size 12px
      text-align right
      +mobile()
        text-align left
        font-size 14px
        line-height 20px
  // &__sticky
  //   position fixed
  //   bottom 0px
  //   height 85px
  //   width 100%
  //   text-align center
  //   background-image url('../../assets/hero_old.jpg')
  //   background-repeat no-repeat
  //   background-position 0% 45%
  //   background-size cover
  //   +mobile()
  //     height 45px
  //   &-wrapper
  //     display inline-block
  //     height 100%
  //     vertical-align middle
  //     line-height 85px
  //     +mobile()
  //       line-height 40px
  //   &-tagline
  //     display inline-block
  //     font-size 20px
  //     color #fff
  //     font-weight 300
  //     +mobile()
  //       font-size 16px
  //   &-try
  //     display inline-block
  //     padding 15px 30px
  //     text-transform uppercase
  //     font-weight 300
  //     +mobile()
  //       margin-left 10px
  //       font-size 14px
  //       padding 10px


</style>



// WEBPACK FOOTER //
// src/components/UIComponents/FooterMenu.vue